<template>
<div class="ams-product-page ">
  <div class="bg-grey">
   <TitleBar :msg="msg"/>
   <div class="row-container doc1">
    <ul>
      <li><span class="management-icon" style="background-position:0 -8.7rem"></span><span>资产管理</span><p class="des">覆盖企业各种实物资产类型管理， 管理资产采购，入库，出库，借用，归还，转移，报修，盘点等流程</p></li>
      <li><span class="management-icon" style="background-position:-2rem -8.7rem"></span><span>耗材管理</span><p class="des">针对耗材出库入库全流程管理，对采购生成的入库单进行入库操作，领料申请生成的领料单进行出库</p></li>
      <li><span class="management-icon" style="background-position:-4rem -8.7rem"></span><span>资产盘点</span><p class="des">通过手机APP，产生盘点单，扫码盘点，也可在PC端进行手动盘点，多方式盘点自由灵活效率高</p></li>
      <li><span class="management-icon" style="background-position:-8rem -8.7rem"></span><span>流程申请审批</span><p class="des">包含资产采购、转移调拨、借用归还、处置等申请审批流程化管理，严密控制每一步操作</p></li>
      <li><span class="management-icon" style="background-position:-6rem -8.7rem"></span><span>折旧处置</span><p class="des">系统自动计算和统计资产折旧信息，对超过使用期限或者状态不良的资产设备可进行处置操作</p></li>
      <li><span class="management-icon" style="background-position:0 -10.7rem"></span><span>统计分析报表</span><p class="des">系统对资产设备和备品耗材自动生成详细的数据报表，可以根据需要选择不同报表导出</p></li>
      <li><span class="management-icon" style="background-position:-2rem -10.7rem"></span><span>个性化自定义</span><p class="des">系统提供众多数据字典和自定义功能，包括资产设备自定义属性，分类，品牌，自定义审批规则和二维码等</p></li>
      <li><span class="management-icon" style="background-position:-4rem -10.7rem"></span><span>RFID标签和二维码</span><p class="des">采用RFID技术和二维码标识资产设备，一键扫描快速识别，保障安全高效管理</p></li>
      <li><span class="management-icon" style="background-position:-6rem -2rem"></span><span>手机移动端操作</span><p class="des">支持安卓、IOS、PDA等移动设备多端登录，协同管理，实时监控资产设备变动与运行状态</p></li>
    </ul>
   </div>
   <div class="buttonzu">
     <el-button class="border-button"  @click="openDocProduct" >了解更多</el-button>
     <el-button type="primary" @click="openConsultBox">免费试用</el-button>
   </div>
  </div>
  <div style="position:relative;" class="doc2">
    <div class="text">
      <p class="title1">资产全生命周期动态信息管理</p>
      <p class="title2">从资产采购、登记管理开始，到报废的资产状态进行监控、报修、转移调拨、处置直至报废整个生命周期的管理</p>
      <!-- <el-button class="border-button"  @click="openConsultBox">免费试用</el-button> -->
    </div>
    <img :src="aimg" alt="" style="width:100%;">
  </div>
  <div class="doc3">
    <div class="imgright">
     <img :src="aimg1" alt="">
    </div>
    <div class="content">
      <p class="title1">快速实现资产标签化管理</p>
      <p class="title2">可自动生成一维/二维条码标签、RFID标签，用户可以根据需要自由选择打印样式和内容，实现个性化标签管理</p>
      <el-button type="primary" @click="openConsultBox" style="margin-top:60px;">免费试用</el-button>
    </div>
  </div>
  <div style="background-color:#f5f7fa;">
    <div class="doc3 doc-right" >
      <div class="content">
        <p class="title1">高效资产盘点</p>
        <ul>
          <li><i class="list-icon"></i>手机移动盘点，只需扫一扫便可读取资产信息</li><li><i class="list-icon"></i>RFID移动盘点，可快速远距离盘点固定资产</li><li><i class="list-icon"></i>支持离线盘点，丰富多样应用场景</li>
        </ul>
        <el-button type="primary" @click="openConsultBox" style="margin-top:60px;">免费试用</el-button>
      </div>
      <div class="imgright">
      <img :src="aimg2" alt="">
      </div>
    </div>
  </div>
  <div class="doc3">
    <div class="imgright">
     <img :src="aimg3" alt="">
    </div>
    <div class="content">
      <p class="title1">资产物联化管理</p>
       <ul>
          <li><i class="list-icon"></i>通过RFID电子标签为每一资产赋予唯一标识</li>
          <li><i class="list-icon"></i>手持机可快速远距离盘点资产</li>
          <li><i class="list-icon"></i>通道门可实时监控物资安全，进行声光报警</li>
          <li><i class="list-icon"></i>读写区可自动采集信息，实现自动盘点、资产定位</li>
        </ul>
      <el-button type="primary" @click="openConsultBox" style="margin-top:60px;">免费试用</el-button>
    </div>
  </div>
  <div style="background-color:#f5f7fa;">
    <div class="doc3 doc-right" >
      <div class="content">
        <p class="title1">精确管理企业易耗品</p>
        <ul>
          <li><i class="list-icon"></i>易耗品库存管理：优化库存，避免浪费</li>
          <li><i class="list-icon"></i>易耗品采购管理：规范流程，降低成本</li>
          <li><i class="list-icon"></i>易耗品领用管理：控制用量，提高效率</li>
          <li><i class="list-icon"></i>易耗品出入库管理：精准管控，高效流转</li>
        </ul>
        <el-button type="primary" @click="openConsultBox" style="margin-top:60px;">免费试用</el-button>
      </div>
      <div class="imgright">
      <img :src="aimg4" alt="">
      </div>
    </div>
  </div>
  <div class="doc4">
    <TitleBar :msg="msg2"/>
    <ul>
      <li><router-link to="/amssolution/1"><img :src='faimg[0]' alt=""><p>无源RFID资产管理</p></router-link></li>
      <li><router-link to="/amssolution/2"><img :src='faimg[1]' alt=""><p>无源RFID资产管理</p></router-link></li>
      <li><router-link to="/amssolution/3"><img :src='faimg[2]' alt=""><p>移动APP资产管理</p></router-link></li>
      <li><router-link to="/amssolution/4"><img :src='faimg[3]' alt=""><p>高校资产管理</p></router-link></li>
      <li><router-link to="/amssolution/5"><img :src='faimg[4]' alt=""><p>政府机关资产管理</p></router-link></li>
      <li><router-link to="/amssolution/6"><img :src='faimg[5]' alt=""><p>IT资产管理</p></router-link></li>
    </ul>
  </div>
  <div style="background-color:#f5f7fa;">
    <div class="doc5">
       <TitleBar :msg="msg3"/>
      <ul>
        <li> <router-link to="/products/8"><span class="management-icon" style="background-position:-3.5rem -9.5rem;"></span><p class="title1">资产管理系统 <span class="arrow-icon"></span></p><p class="des">实现资产从采购、入库、领用、维修到报废的全生命周期数字化管理</p></router-link></li>
        <li> <router-link to="/amshandwareProducts"><span class="management-icon" style="background-position:-10.5rem -6rem;"></span><p class="title1">相关硬件搭配<span class="arrow-icon"></span></p><p class="des">所需的相关硬件，包括条码打印机/扫描枪/高速扫描仪等</p></router-link></li>
      </ul>
    </div>
  </div>
 
</div>
</template>
<script>
import TitleBar from './TitleBar.vue'

import a from '../assets/amsbannner1.png'
import a1 from '../assets/amsbannner2.png'
import a2 from '../assets/amsbannner3.png'
import a3 from '../assets/amsbannner4.png'
import a4 from '../assets/amsbannner5.png'
import fa1 from '../assets/amsFA1.png'
import fa2 from '../assets/amsFA2.png'
import fa3 from '../assets/amsFA3.png'
import fa4 from '../assets/amsFA4.png'
import fa5 from '../assets/amsFA5.png'
import fa6 from '../assets/amsFA6.png'
import { get, imageFile } from '../plugins/request.js'
import getQueryString from '../plugins/getQueryString.js'

export default {
  name: 'amsProductPage',
  components: {
    TitleBar
  },
  data() {
    return {
      msg: {
        title: '智慧资产管理一体化解决方案',
        subTitle: '强大的系统功能，优质的用户体验'
      },
      msg2: {
        title: '解决方案',
        subTitle: '根据流程和需求，量身定制个性化解决方案'
      },
      msg3: {
        title: '更多的相关软件产品',
        subTitle: '软件系统和硬件搭配方案，资产全生命周期的智能化管理'
      },
      aimg:a,
      aimg1:a1,
      aimg2:a2,
      aimg3:a3,
      aimg4:a4,
      faimg:[fa1,fa2,fa3,fa4,fa5,fa6],
      items: [
        { title: '', des: '' },
        { title: '', des: '' },
        { title: '', des: '' }
      ]
    }
  },
  methods: {
    openConsultBox(){
      window.$crisp.push(['do', 'chat:open']);
    },
    openDocProduct(){
      this.$router.push('/products/8')
    }
  },
  created: function(){
   
  },  
}
</script>
<style lang="scss">
.ams-product-page {
  font-size: 0.8rem;
  line-height: 2;
  .bg-grey{
    background: #f5f7fa;
    padding-bottom: 2.5rem;
  }
  .buttonzu{
    text-align: center;
    margin-top: 1.5rem;
    .el-button.border-button{
      color: #444444;
    }
    .el-button.border-button:hover{
      border-color: #409EFF !important;
      background-color:transparent !important;
      color: #409EFF !important;
    }
  }
  
  .doc1{
    ul{
      display: flex;
      justify-content: space-around;
      flex-flow: row wrap;
      li{
        background:#fff;
        border-radius: 4px;
        display: inline-block;
        flex: 0 1 30%;
        font-size: 14px;
        padding: 1rem 2rem;
        box-shadow: 8px 8px 20px 0 rgba(55, 99, 170, .1);
        margin-bottom: 2rem;
        word-break: break-all;
        span{
          font-size: 20px;
          font-weight: 600;
          
        }
        p{
          line-height: 20px;
        }
        .des{
          margin-top: 0.7rem;
        }
      }
    }
    .management-icon{
      display: inline-block;
      width: 2rem;
      height: 2rem;
      background: url(../assets/docIcons.png) no-repeat center;
      background-position:0 0;
      border: 0;
      background-size: 500%;
      vertical-align: -10px;
      margin-right: 10px;
    }
  }
  .doc2{
    .text{
      width: 1240px;
      position: absolute;
      top: 40%;
      left: 50%;
      -webkit-transform: translate(-50%, -50%);
      transform: translate(-50%, -50%);
      color: #fff;
      text-align: left;
      padding: 0 2rem;
      .title1{
        font-size: 36px;
        font-weight: 600;
      }
      .title2{
        width: 22rem;
        margin-bottom: 2rem;
        line-height: 1.4;
      }
    }
    &.blackbg{
      background: #22273d;
      .text{
        text-align: center;
        top: 20%;
        .title2{
          width: 100%;
        }
      }
    }
    
  }
  
  .doc3{
    display: flex;
    justify-content: space-between;
    max-width: 1340px;
    padding-left:0;
    padding-right:3rem;
    margin: 0 auto;
    align-items: center;
    &.doc-right{padding-left:3rem;padding-right:0;}
    .content{
      .title1{
        margin-bottom: 10px;
        font-size:32px;
        font-weight: 600;
      }
      .title2{
        font-size:20px;
        color:#353535;
        line-height: 1.4;
        width: 340px;
      }
    }
  }
  .doc4{
    max-width: 1400px;
    margin: 0 auto;
    text-align: center;
    ul{
      display: flex;
      justify-content: space-around;
      flex-flow: row wrap;
      li{
        display: inline-block;
        flex: 0 1 30%;
        font-size: 14px;
        border-radius: 6px;
        p{
          font-size: 18px;
          margin-bottom: 2rem;
        }
      }
      li:hover img{
        box-shadow: 0 8px 20px 0 rgba(55, 99, 170, .2);}
    }
  }
  .doc5{
    text-align: center;
    margin: 0 auto;
    max-width: 1400px;
    ul{
      display: flex;
      justify-content: space-around;
      flex-flow: row wrap;
      li{
        background:#fff;
        border-radius: 4px;
        display: inline-block;
        flex: 0 1 46%;
        margin-bottom: 2.5rem;
        a{
          display: block;
          text-align: left;
          font-size: 16px;
          padding: 2rem 2rem;
          .title1{
            font-size: 20px;
            font-weight: 600;
          }
        }
      }
      li:hover{
        box-shadow: 8px 8px 20px 0 rgba(55, 99, 170, .1);
        .title1{
          color: #2a7acc;
        }
         .arrow-icon{
          background-position:-280px -137px;
        }
      }
    }
    .management-icon{
      display: inline-block;
      width: 3.2rem;
      height: 3.2rem;
      background: url(../assets/docIcons.png) no-repeat center;
      background-position:0 0;
      border: 0;
    }
    .arrow-icon{
      display: inline-block;
      width: 10px;
      height: 18px;
      background: url(../assets/docIcons.png) no-repeat center;
      background-position:-280px -120px;
      margin-left: 10px;
      vertical-align: -1px;
    }
    
  }
  .list-icon{
      display: inline-block;
      width: 20px;
      height: 20px;
      background: url(../assets/docIcons.png) no-repeat center;
      background-position:-278px -156px;
      margin-right: 10px;
      vertical-align: -4px;
    }
}
</style>